var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.84429 18.0699L16.864 8.05021L16.864 14.9516C16.864 15.5031 17.3165 15.9557 17.8681 15.9557C18.4196 15.9557 18.8651 15.5102 18.8651 14.9586L18.8651 5.63897C18.8654 5.37446 18.7605 5.12069 18.5734 4.93364C18.3864 4.7466 18.1326 4.64166 17.8681 4.64195L8.54842 4.62781C7.99688 4.62781 7.5514 5.07329 7.5514 5.62483C7.5514 6.17638 7.99688 6.62185 8.54842 6.62185L15.4498 6.63599L5.43008 16.6557C5.04117 17.0446 5.04117 17.681 5.43008 18.0699C5.81899 18.4588 6.45538 18.4588 6.84429 18.0699Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandWhiteIcon);
export default __webpack_public_path__ + "static/media/expandWhiteIcon.204154e2818f5186fa34ac70e9f6faf7.svg";
export { ForwardRef as ReactComponent };